
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPinIcon } from "lucide-react";

interface PlotDetailsProps {
  name: string;
  description?: string | null;
}

export const PlotDetails = ({ name, description }: PlotDetailsProps) => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center">
          <MapPinIcon className="mr-2 h-5 w-5" />
          Información de la Parcela
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <h3 className="text-base font-medium text-muted-foreground">Nombre</h3>
            <p className="text-base">{name}</p>
          </div>
          {description && (
            <div>
              <h3 className="text-base font-medium text-muted-foreground">Descripción</h3>
              <p className="text-base">{description}</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
